<div class="card snapshot-card" data-cy="portfolio-snapshot-card">
	<div class="header">
		<div class="title">Portfolio Snapshot</div>

		<!-- Meta (real) -->
		<div class="meta" *ngIf="!loading && snapshot?.lastAiRunDate">
			Last AI Run: <b>{{ formatDate(snapshot?.lastAiRunDate ?? null) }}</b>
		</div>

		<!-- Meta (skeleton) -->
		<div class="meta" *ngIf="loading">
			<p-skeleton width="14rem" height="0.9rem"></p-skeleton>
		</div>
	</div>

	<!-- Loading (skeleton) -->
	<div *ngIf="loading" class="content skeleton-content">
		<!-- Big headline metrics -->
		<div class="metric-block">
			<div class="label">
				<p-skeleton width="12rem" height="0.9rem"></p-skeleton>
			</div>
			<div class="value financial">
				<p-skeleton width="10rem" height="2.2rem"></p-skeleton>
			</div>
		</div>

		<div class="metric-block">
			<div class="label">
				<p-skeleton width="13rem" height="0.9rem"></p-skeleton>
			</div>
			<div class="value operational">
				<p-skeleton width="7rem" height="2.2rem"></p-skeleton>
			</div>
		</div>

		<!-- Compact stats grid -->
		<div class="stats-grid">
			<div class="stat" *ngFor="let i of [1,2,3,4]">
				<div class="stat-label">
					<p-skeleton width="6rem" height="0.8rem"></p-skeleton>
				</div>
				<div class="stat-value">
					<p-skeleton width="3rem" height="1.1rem"></p-skeleton>
				</div>
			</div>
		</div>

		<div class="divider"></div>

		<!-- Nav rows -->
		<div class="nav-row">
			<div class="nav-label">
				<p-skeleton width="9rem" height="0.9rem"></p-skeleton>
			</div>
			<div class="nav-value">
				<p-skeleton width="6rem" height="0.9rem"></p-skeleton>
			</div>
		</div>

		<div class="nav-row">
			<div class="nav-label">
				<p-skeleton width="9rem" height="0.9rem"></p-skeleton>
			</div>
			<div class="nav-value">
				<p-skeleton width="6rem" height="0.9rem"></p-skeleton>
			</div>
		</div>
	</div>

	<!-- Error -->
	<div *ngIf="!loading && errorStatus" class="state error">
		<div class="pill">Error loading snapshot ({{ errorStatus }})</div>
	</div>

	<!-- Empty -->
	<div *ngIf="!loading && !errorStatus && showEmptyState" class="state empty">
		<div class="pill">No data yet (select an organisation)</div>
	</div>

	<!-- Data -->
	<div *ngIf="!loading && !errorStatus && snapshot" class="content">
		<div class="metric-block">
			<div class="label">Total Financial Risk ($)</div>
			<div class="value financial">
				{{ snapshot.financialRiskAmount | currency:'USD':'symbol':'1.0-0' }}
			</div>
		</div>

		<div class="metric-block">
			<div class="label">Total Operational Risk (#)</div>
			<div class="value operational">
				{{ snapshot.nonFinancialItemsCount ?? 0 }}
				<span class="unit">Items</span>
			</div>
		</div>

		<div class="stats-grid">
			<div class="stat">
				<div class="stat-label">Properties</div>
				<div class="stat-value">{{ snapshot.propertiesCount ?? 0 }}</div>
			</div>

			<div class="stat">
				<div class="stat-label">Launched</div>
				<div class="stat-value">{{ snapshot.totalTasksInstanceLaunched ?? 0 }}</div>
			</div>

			<div class="stat">
				<div class="stat-label">Completed</div>
				<div class="stat-value">{{ snapshot.totalCompleted ?? 0 }}</div>
			</div>

			<div class="stat">
				<div class="stat-label">Processed</div>
				<div class="stat-value">{{ snapshot.totalProcessed ?? 0 }}</div>
			</div>
		</div>

		<div class="divider"></div>

		<div class="nav-row" [class.disabled]="highRiskHotelsCount === null">
			<div class="nav-label">High Risk Hotels</div>
			<div class="nav-value">
				<ng-container *ngIf="highRiskHotelsCount !== null; else hotelsDash">
					{{ highRiskHotelsCount }} Hotels
				</ng-container>
				<ng-template #hotelsDash>-</ng-template>
			</div>
		</div>

		<div class="nav-row" [class.disabled]="highRiskReportsCount === null">
			<div class="nav-label">High Risk Reports</div>
			<div class="nav-value">
				<ng-container *ngIf="highRiskReportsCount !== null; else reportsDash">
					{{ highRiskReportsCount }} Reports
				</ng-container>
				<ng-template #reportsDash>-</ng-template>
			</div>
		</div>
	</div>
</div>
